import React from "react";
import {PlayersStatisticsTableColumnViewModel} from "../../../../domain/yard/lineups/players-statistics/tables/columns/players-statistics.table.column.view-model";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import classnames from "classnames";
import styles from "../../styles/box-scores-widget.module.scss";

class BoxScoresWidgetTableStatsColumnsProps extends BaseProps {
  columns: Array<PlayersStatisticsTableColumnViewModel>;
}

export const BoxScoresWidgetTableStatsColumns = (({columns}: BoxScoresWidgetTableStatsColumnsProps) => {
  return (
    <div className={classnames(styles.table_row, styles.table_header_container)}>
      {
        columns.map((column: PlayersStatisticsTableColumnViewModel) =>
          <div key={column.num} className={classnames(styles.table_cell, styles.table_header)}>
            {column.shortName.toLocaleUpperCase()}
          </div>)
      }
    </div>
  )
});
